import React from "react";
import { SelectField } from "ui-components";
import MenuItem from "material-ui/MenuItem";

const AssessmentSelection = ({ value, onChange }) => {
  return (
    <SelectField
      value={value}
      onChange={onChange}
      large
      fullWidth
      style={{ backgroundColor: "#fff" }}
      hintText="Select Assessment Tool"
    >
      <MenuItem value={"previsit"} primaryText="Pre-Visit" />
      <MenuItem value={"pretravel"} primaryText="Pre-Travel" />
      <MenuItem value={"homecommunity"} primaryText="Home/Community" />
    </SelectField>
  );
};

export default AssessmentSelection;



// WEBPACK FOOTER //
// ./src/landing/AssessmentSelection.jsx